var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9481_16494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 31.9988C32 31.9994 31.9994 32 31.9988 32H0.00118519C0.000592593 32 0 31.9994 0 31.9988V0.00118519C0 0.000592593 0.000592593 0 0.00118519 0H31.9991C31.9997 0 32.0003 0.000592593 32.0003 0.00118519V31.9988H32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4665 31.4673C31.4665 31.4679 31.4659 31.4685 31.4653 31.4685H0.534388C0.533796 31.4685 0.533203 31.4679 0.533203 31.4673V0.536341C0.533203 0.535749 0.533796 0.535156 0.534388 0.535156H31.4656C31.4662 0.535156 31.4668 0.535749 31.4668 0.536341V31.4673H31.4665Z",
    fill: "#D00000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97686 24.4058C8.97686 24.4292 8.99049 24.4618 9.00679 24.4781L9.53627 25.0076C9.55286 25.0242 9.58545 25.0375 9.60856 25.0375H11.4204C11.4438 25.0375 11.4764 25.0239 11.4927 25.0076L12.0222 24.4781C12.0388 24.4615 12.0521 24.4289 12.0521 24.4058V18.6567C12.0521 18.6333 12.066 18.601 12.0829 18.585L14.3849 16.3865C14.4017 16.3705 14.4263 16.3729 14.4394 16.3924L20.2554 25.0028C20.2684 25.0221 20.2983 25.0381 20.3215 25.0381H22.8883C22.9117 25.0381 22.9395 25.0212 22.9502 25.0004L23.416 24.0979C23.4266 24.0772 23.4246 24.0446 23.4112 24.0253L16.6083 14.1646C16.5949 14.1453 16.5976 14.1163 16.6142 14.0997L22.8714 7.87186C22.888 7.85526 22.9013 7.82297 22.9013 7.79956V7.6846C22.9013 7.66119 22.8936 7.62475 22.8844 7.60312L22.5235 6.77319C22.5143 6.75186 22.4874 6.73438 22.4643 6.73438H19.9271C19.9037 6.73438 19.8711 6.748 19.8548 6.7643L12.0826 14.5658C12.066 14.5824 12.0527 14.5767 12.0527 14.5533V7.3963C12.0527 7.37289 12.0397 7.34 12.0237 7.32282L11.5043 6.76578C11.4883 6.7486 11.4563 6.73467 11.4329 6.73467H9.60856C9.58516 6.73467 9.55316 6.7486 9.53716 6.76578L9.0053 7.34C8.9893 7.35719 8.97656 7.39008 8.97656 7.41349V24.4058H8.97686Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9481_16494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo14);
export default __webpack_public_path__ + "static/media/logo14.cfaa48005605c3bdc2f507f9ec40445b.svg";
export { ForwardRef as ReactComponent };